export const getMessageStyles = (message, index, messagesArr) => {
    const prevMessage = index > 0 ? messagesArr[index - 1] : null;
    const nextMessage = index < messagesArr.length - 1 ? messagesArr[index + 1] : null;
    const isFirst = prevMessage === null || prevMessage.channel !== message.channel;
    const isLast = nextMessage === null || nextMessage.channel !== message.channel;
    const isAdmin = message.channel === 'admin';
    const showMessageTime = nextMessage === null || nextMessage.channel !== message.channel;
    const marginTop = isFirst ? '16px' : '6px';
    let borderRadius = '16px';
    if (isFirst && !isLast)
        borderRadius = isAdmin ? '16px 16px 16px 6px' : '16px 16px 6px 16px';
    if (!isFirst && !isLast)
        borderRadius = isAdmin ? '6px 16px 16px 6px' : '16px 6px 6px 16px';
    if (!isFirst && isLast)
        borderRadius = isAdmin ? '6px 16px 16px 16px' : '16px 6px 16px 16px';
    return { borderRadius, marginTop, showMessageTime };
};
